import { AbstractControl, ValidatorFn } from '@angular/forms';

export const validateFiletype = (file: File, allowedTypes: string[]) => {
    return allowedTypes.indexOf(file.type) !== -1;
};

export const validateFileExtension = (file: File, allowedExtension: string[]) => {
    const getExt = (filename) => {
        const ext = filename.split('.').pop();
        if (ext === filename) {
            return '';
        }
        return '.' + ext.toLowerCase();
    };

    return allowedExtension.indexOf(getExt(file.name)) !== -1;
};

export const filetype = (allowedTypes: string[], allowedExtension: string[]): ValidatorFn => {
    return (control: AbstractControl): { [key: string]: boolean } => {
        const v: File = control.value;

        if (!v) {
            return null;
        }

        return validateFiletype(v, allowedTypes) && validateFileExtension(v, allowedExtension) ? null : { filetype: true };
    };
};
